// src/components/DepositInvoiceModal.tsx
import React, { useState } from 'react';
import { Modal, Button, Form } from 'react-bootstrap';

interface DepositInvoiceFormData {
  contact: string;
  amount: number;
}

interface DepositInvoiceModalProps {
  show: boolean;
  onHide: () => void;
  defaultContactUrl: string;  // we can pass the estimate's contact URL
  defaultCurrency: string;    // from the estimate
  onSubmit: (formData: DepositInvoiceFormData) => void;
}

const DepositInvoiceModal: React.FC<DepositInvoiceModalProps> = ({
  show,
  onHide,
  defaultContactUrl,
  defaultCurrency,
  onSubmit,
}) => {
  // Basic form fields in local state
  const [contact, setContact] = useState<string>(defaultContactUrl || '');
  const [amount, setAmount] = useState<number>(0);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit({ contact, amount });
  };

  return (
    <Modal show={show} onHide={onHide}>
      <Form onSubmit={handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Create Deposit Invoice</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Contact (readonly or allow user to override) */}
          <Form.Group className="mb-3">
            <Form.Label>Contact (FreeAgent URL)</Form.Label>
            <Form.Control
              type="text"
              value={contact}
              onChange={(e) => setContact(e.target.value)}
            />
          </Form.Group>

          {/* Deposit amount */}
          <Form.Group className="mb-3">
            <Form.Label>Deposit Amount</Form.Label>
            <Form.Control
              type="number"
              step="0.01"
              placeholder="Enter deposit amount"
              value={amount}
              onChange={(e) => setAmount(parseFloat(e.target.value))}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Create Invoice
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default DepositInvoiceModal;
